import API from './axios.js';

export const getMembers = (requireID) => API.get(`auth/user-id?id=${requireID}`);